import { takeEvery } from 'redux-saga/effects';
import { createSurvey } from './create-survey';
import { fetchSurveys } from './fetch-surveys';
import { fetchSurvey } from './fetch-survey';
import { updateSurvey } from './update-survey';

import { createSurveyParcels } from './create-survey-parcels';
import { deleteSurveyParcel } from './delete-survey-parcel';
import { fetchSurveyParcels } from './fetch-survey-parcels';

import { createFieldDefinition } from './create-field-definition';
import { deleteFieldDefinition } from './delete-field-definition';
import { fetchFieldDefinitions } from './fetch-field-definitions';
import { updateFieldDefinition } from './update-field-definition';
import { createSurveyAccount } from './create-survey-account';
import { deleteSurveyAccount } from './delete-survey-account';
import { fetchSurveyAccounts } from './fetch-survey-accounts';
import { createFieldChange } from './create-field-change';
import { deleteFieldChange } from './delete-field-change';
import { downloadSurveyCSV } from './download-survey-csv';

export function* createSurveySaga() {
  yield takeEvery(['CREATE_SURVEY'], createSurvey);
}

export function* fetchSurveysSaga() {
  yield takeEvery(['FETCH_SURVEYS'], fetchSurveys);
}

export function* fetchSurveySaga() {
  yield takeEvery(['FETCH_SURVEY'], fetchSurvey);
}

export function* updateSurveySaga() {
  yield takeEvery(['UPDATE_SURVEY'], updateSurvey);
}

export function* fetchSurveyParcelsSaga() {
  yield takeEvery(['FETCH_SURVEY_PARCELS'], fetchSurveyParcels);
}

export function* createSurveyParcelsSaga() {
  yield takeEvery(['CREATE_SURVEY_PARCELS'], createSurveyParcels);
}

export function* deleteSurveyParcelsSaga() {
  yield takeEvery(['DELETE_SURVEY_PARCEL'], deleteSurveyParcel);
}

export function* fetchFieldDefinitionsSaga() {
  yield takeEvery(['FETCH_FIELD_DEFINITIONS'], fetchFieldDefinitions);
}

export function* updateFieldDefinitionsSaga() {
  yield takeEvery(['UPDATE_FIELD_DEFINITION'], updateFieldDefinition);
}

export function* createFieldDefinitionsSaga() {
  yield takeEvery(['CREATE_FIELD_DEFINITION'], createFieldDefinition);
}

export function* deleteFieldDefinitionsSaga() {
  yield takeEvery(['DELETE_FIELD_DEFINITION'], deleteFieldDefinition);
}

export function* createSurveyAccountSaga() {
  yield takeEvery(['CREATE_SURVEY_ACCOUNT'], createSurveyAccount);
}

export function* deleteSurveyAccountSaga() {
  yield takeEvery(['DELETE_SURVEY_ACCOUNT'], deleteSurveyAccount);
}

export function* fetchSurveyAccountsSaga() {
  yield takeEvery(['FETCH_SURVEY_ACCOUNTS'], fetchSurveyAccounts);
}

export function* createFieldChangeSaga() {
  yield takeEvery(['CREATE_FIELD_CHANGE'], createFieldChange);
}

export function* deleteFieldChangeSaga() {
  yield takeEvery(['DELETE_FIELD_CHANGE'], deleteFieldChange);
}

export function* downloadSurveyCSVSaga() {
  yield takeEvery(['DOWNLOAD_SURVEY_CSV'], downloadSurveyCSV);
}
